import {useEffect, useRef} from "react";
import {useSelector} from "react-redux";
import {RootState} from "../store";
import {SessionType, trackSessionComplete, trackSessionStart} from "./events";

// Therapist (host) window only. A session STARTS when the patient connects for
// the first time in this window, so testing the light alone is not a session.
// It COMPLETES when the therapist closes or leaves the window (pagehide) or the
// view unmounts; there is no explicit "end session" action in the app yet.
// sets_count counts sets started while the patient was connected (the counter
// the therapist sees), ignoring "restart sets".
// TODO(team): confirm both definitions with the agency before publishing tags.
export function useSessionAnalytics(isClientJoined: boolean, sessionType: SessionType = "online"): void {
    const sets = useSelector((state: RootState) => state.therapyConfiguration.sets);
    const startedAt = useRef<number | null>(null);
    const completed = useRef(false);
    const setsCount = useRef(0);
    const previousSets = useRef(sets);

    useEffect(() => {
        if (isClientJoined && startedAt.current === null) {
            startedAt.current = Date.now();
            trackSessionStart(sessionType);
        }
    }, [isClientJoined, sessionType]);

    useEffect(() => {
        if (startedAt.current !== null && sets > previousSets.current) {
            setsCount.current += sets - previousSets.current;
        }
        previousSets.current = sets;
    }, [sets]);

    useEffect(() => {
        const complete = () => {
            if (startedAt.current === null || completed.current) {
                return;
            }
            completed.current = true;
            trackSessionComplete(
                sessionType,
                Math.round((Date.now() - startedAt.current) / 1000),
                setsCount.current,
            );
        };
        window.addEventListener("pagehide", complete);
        return () => {
            window.removeEventListener("pagehide", complete);
            complete();
        };
    }, [sessionType]);
}
